(function () {
    var bp = breakpoints.md;
    var mqCarouselMobyleOnly = window.matchMedia('(min-width: ' + bp + 'px)');

    document.addEventListener("DOMContentLoaded", function (event) {
        var mobileCarousels = document.querySelectorAll(".siema-carousel.three-col-carousel.has-arrows .slides");
        var isIe = detectIE();

        Array.prototype.forEach.call(mobileCarousels, function (el, i) {
            var carouselMobyleOnly = new Siema({
                selector: mobileCarousels[i],
                duration: 200,
                easing: 'ease-out',
                perPage: {
                    600: 2,
                    1024: 3,
                },

                onInit: function () {
                    this.addPagination();
                    this.updatePagination();
                    this.slideToCurrent();
                    this.addArrows();
                    this.updateArrows();
                    this.setAutoHeight(this);

                    if (isIe) {
                        let thisCarousel = this;
                        cssVars({
                            onComplete: function () {
                                thisCarousel.resizeHandler();
                                thisCarousel.setAutoHeight(this);
                            }
                        });
                    }
                },
                onChange: function () {
                    this.updatePagination();
                    this.updateArrows();
                    this.setAutoHeight(this);
                }
            });

        });
    });

})();